module.exports = __webpack_public_path__ + "static/media/freetrial.4f3209c1.png";